const ROUTES = {
  ROOT: {
    INDEX: {
      PATH: '/',
      URL: () => '/',
    },
  },
  AUTH: {
    LOGIN: {
      PATH: '/login',
      URL: () => '/login',
    },
  },
  DASHBOARD: {
    INDEX: {
      PATH: '/dashboard',
      URL: () => '/dashboard',
    },
  },
  USERS: {
    INDEX: {
      PATH: '/users',
      URL: () => '/users',
    },
    EDIT: {
      PATH: '/users/edit/:id?',
      URL: (id) => `/users/edit/${id}`,
    },
  },
  TRANSACTIONS: {
    INDEX: {
      PATH: '/transactions',
      URL: () => '/transactions',
    },
    REPORT: {
      PATH: '/transactions/report',
      URL: () => '/transactions/report',
    },
    SETTINGS: {
      PATH: '/transactions/settings',
      URL: () => '/transactions/settings',
    },
    SPECIAL_OFFERS: {
      INDEX: {
        PATH: '/transactions/special_offers',
        URL: () => '/transactions/special_offers',
      },
      EDIT: {
        PATH: '/transactions/special_offers/:type?/:id?',
        URL: (
          id = '',
          type = 'new',
        ) => `/transactions/special_offers/${type}${id ? `/${id}` : ''}`,
      },
    },
  },
  PROMO_CODES: {
    INDEX: {
      PATH: '/promo_codes',
      URL: () => '/promo_codes',
    },
    EDIT: {
      PATH: '/promo_codes/:type?/:id?',
      URL: (
        id = '',
        type = 'new',
      ) => `/promo_codes/${type}${id ? `/${id}` : ''}`,
    },
  },
  REFERRALS: {
    INDEX: {
      PATH: '/referrals',
      URL: () => '/referrals',
    },
    ADD_CONVERSION: {
      PATH: '/referrals/add',
      URL: () => '/referrals/add',
    },
  },
  DOMAINS: {
    INDEX: {
      PATH: '/domains',
      URL: () => '/domains',
    },
  },
  NETWORK_PRESETS: {
    INDEX: {
      PATH: '/network_presets',
      URL: () => '/network_presets',
    },
    EDIT: {
      PATH: '/network_presets/:type?/:id?',
      URL: (
        id = '',
        type = 'new',
      ) => `/network_presets/${type}${id ? `/${id}` : ''}`,
    },
  },
  SOURCE_PRESETS: {
    INDEX: {
      PATH: '/source_presets',
      URL: () => '/source_presets',
    },
    EDIT: {
      PATH: '/source_presets/:type?/:id?',
      URL: (
        id = '',
        type = 'new',
      ) => `/source_presets/${type}${id ? `/${id}` : ''}`,
    },
  },
  PRESET_CATEGORIES: {
    INDEX: {
      PATH: '/categories_for_presets',
      URL: () => '/categories_for_presets',
    },
  },
  NEWS: {
    INDEX: {
      PATH: '/news',
      URL: () => '/news',
    },
    EDIT: {
      PATH: '/news/:type?/:id?',
      URL: (
        id = '',
        type = 'new',
      ) => `/news/${type}${id ? `/${id}` : ''}`,
    },
  },
  TRAFFIC_FILTERS: {
    INDEX: {
      PATH: '/traffic_filters',
      URL: () => '/traffic_filters',
    },
  },
  SYSTEM: {
    400: {
      PATH: '/400',
    },
    401: {
      PATH: '/401',
    },
    404: {
      PATH: '/404',
    },
    500: {
      PATH: '/500',
    },
    502: {
      PATH: '/502',
    },
  },
};

export default ROUTES;
